module.exports = __webpack_public_path__ + "img/CASTiT.0beef15b.png";